export const SITE_VERSION = "7";
